import React, { Suspense, lazy } from 'react';
import { CLIENT_URL } from '../../lib/host';
import { LOGO_URL, PRODUCT_NAME } from '../../config/branding';

// 🔴 ИЗМЕРЕНО 04.09.2026, и результат противоположен ожиданию: динамический
// `import()` внутри ложной ветки НЕ убирает чанк из сборки. Разделение кода webpack
// делает по графу модулей, до минификации; терсер потом сворачивает ветку внутри
// чанка, но сам файл уже создан и лежит в build/static/js. Замер: сборка onprem
// вынесла реквизиты из main.js, но оставила их в четырёх .chunk.js.
// Что это даёт и чего не даёт: клиент, открывший приложение, договор не скачивает —
// чанк не запрашивается. Но файл лежит у него на диске, и `grep` по build/ находит
// ИНН. Настоящее решение — не отдавать эти данные модулем JS вовсе;
// см. docs/backlog/client-edition-split.md.
const IS_SAAS = (process.env.REACT_APP_EDITION || 'saas') !== 'onprem';

// Подвал с реквизитами юрлица — наш и только наш. В сборке onprem его нет.
const LegalFooter = IS_SAAS ? lazy(() => import('./LegalFooter')) : null;

// Шапка и подвал публичных страниц: всё, что видно ДО логина.
//
// До 17.08.2026 публичной части не было вовсе — App.js на любой путь отдавал форму
// входа, и посетитель (в том числе модератор ЮKassa) видел два поля ввода без единого
// слова о том, что это за сервис, сколько стоит и с кем он имеет дело.

// Пункты ведут на секции витрины. На домене сотрудников витрины нет, поэтому
// там шапка пустая — иначе ссылки вели бы в никуда, как это уже случилось на
// клиентском домене до 19.08.2026.
export const NAV = [
  { href: '/', label: 'О сервисе' },
  { href: '/#tariffs', label: 'Тарифы' },
  { href: '/#payment', label: 'Оплата и возврат' },
  { href: '/#contacts', label: 'Контакты' },
];

export default function PublicShell({ children, nav = NAV }) {
  return (
    <div className="min-h-screen flex flex-col bg-paper-bg text-paper-ink">
      {/* Пустой nav — это экран сотрудника: у него логотип стоит в самой карточке,
          как в «Бумаге». Шапка с одним логотипом дала бы его дважды на одном
          экране, поэтому её тут нет вовсе, а не «есть, но пустая». */}
      {nav.length > 0 && (
        <header className="border-b border-paper-line">
          <div className="mx-auto max-w-5xl px-4 py-4 flex flex-wrap items-center gap-x-6 gap-y-2">
            {/* Витрина клиентского домена, а не «/»: оферту и согласие открывают и
                со служебного адреса, где «/» — вход сотрудников (прогон 24.09). */}
            <a href={CLIENT_URL || '/'} className="flex items-center gap-3 shrink-0">
              <img src={LOGO_URL} alt={PRODUCT_NAME} className="h-8 w-auto" />
            </a>
            <nav className="flex flex-wrap items-center gap-x-5 gap-y-1 text-[13px]">
              {nav.map((item) => (
                <a key={item.href} href={item.href} className="text-paper-ink-2 hover:text-paper-accent">
                  {item.label}
                </a>
              ))}
            </nav>
          </div>
        </header>
      )}

      <main className="flex-1">{children}</main>

      {LegalFooter && (
        <footer className="border-t border-paper-line">
          <Suspense fallback={null}><LegalFooter /></Suspense>
        </footer>
      )}
    </div>
  );
}
